import React from 'react';
import { FcOk } from "react-icons/fc";
import { GiCancel } from "react-icons/gi";

import './PriceSection.css';

const PriceSection = () => {
    return (
        <div className="container price__container">
           <h5 className="price__mainHeading">
                Deal for your investment
            </h5>
            <h2 className="price__subHeading">
                Meet our pricing plan that suit you
            </h2>
            <div className="row my-5">
                <div className="col-md-3">

                </div>
                <div className="col-md-3 d-flex flex-column align-items-center">
                    <span className="price__packHeading">
                        Starter Pack
                    </span>
                    <hr/>
                    <strong className="price__priceHeading">
                        $18.99/per mo.
                    </strong>
                </div>
                <div className="col-md-3 d-flex flex-column align-items-center">
                    <span className="price__packHeading">
                        Premium Pack
                    </span>
                    <hr/>
                    <strong className="price__priceHeading">
                        $23.99/per mo.
                    </strong>
                </div>
                <div className="col-md-3 d-flex flex-column align-items-center">
                    <span className="price__packHeading">
                        Custom Pack
                    </span>
                    <hr/>
                    <strong className="price__priceHeading">
                        $29.99/per mo.
                    </strong>
                </div>
            </div>
            <div className="row my-5">
                <div className="col-md-3">
                    <strong>
                        Stock Analysis
                    </strong>
                </div>
                <div className="col-3 text-center">
                   <FcOk size={20}/>
                </div>
                <div className="col-3 text-center">
                    <FcOk size={20}/>
                </div>
                <div className="col-3 text-center">
                    <FcOk size={20}/>
                </div>
            </div>
            <div className="row my-5">
                <div className="col-md-3">
                    <strong>
                        Personal Portfolio
                    </strong>
                </div>
                <div className="col-3 text-center">
                   <GiCancel  color="#7B8188" size={20}/> 
                </div>
                <div className="col-3 text-center">
                    <FcOk size={20} />
                </div>
                <div className="col-3 text-center">
                    <FcOk size={20} />
                </div>
            </div>
            <div className="row my-5">
                <div className="col-md-3">
                    <strong>
                        Portfolio Optimizations
                    </strong>
                </div>
                <div className="col-3 text-center">
                   <GiCancel color="#7B8188" size={20}/>
                </div>
                <div className="col-3 text-center">
                    <FcOk size={20} />
                </div>
                <div className="col-3 text-center">
                    <FcOk size={20} />
                </div>
            </div>
            <div className="row my-5">
                <div className="col-md-3">
                    <strong>
                        Personalized Recommendations
                    </strong>
                </div>
                <div className="col-3 text-center">
                   <GiCancel color="#7B8188" size={20}/>
                </div>
                <div className="col-3 text-center">
                    <GiCancel color="#7B8188" size={20}/>
                </div>
                <div className="col-3 text-center">
                    <FcOk size={20}/>
                </div>
            </div>
        </div>
    )
}

export default PriceSection
